document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('[data-search-toggle]'),p=document.querySelector('[data-search-panel]');if(b&&p)b.addEventListener('click',()=>{p.classList.toggle('open');if(p.classList.contains('open'))p.querySelector('input').focus()});document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'})}}));});
document.addEventListener('submit',function(e){
  const form=e.target;
  if(!form || form.id!=='ProductFormV4') return;
  const btn=form.querySelector('.product-submit-v4');
  if(btn){
    btn.classList.add('is-loading');
    const label=btn.querySelector('span');
    if(label) label.textContent='ADDING...';
    setTimeout(()=>{ if(label) label.textContent='ADDED ✓'; setTimeout(()=>{if(label) label.textContent='ADD TO CART'},1100)},650);
  }
});

/* Premium category interaction: instant orange glow + current collection state */
document.addEventListener('DOMContentLoaded',()=>{
  const cards=[...document.querySelectorAll('.category-grid .cat-card')];
  if(!cards.length) return;

  const normalize=(value)=>String(value||'').toLowerCase().replace(/^\/+|\/+$/g,'');
  const pathParts=location.pathname.split('/').filter(Boolean);
  const currentHandle=pathParts[0]==='collections' ? normalize(pathParts[1]) : '';

  cards.forEach(card=>{
    if(currentHandle && normalize(card.dataset.category)===currentHandle){
      card.classList.add('is-active');
      card.setAttribute('aria-current','page');
    }

    card.addEventListener('click',()=>{
      cards.forEach(other=>other.classList.remove('is-active'));
      card.classList.add('is-active');
      // Keep the glow visible while Shopify changes pages.
      card.style.setProperty('transition-duration','.05s');
    });
  });
});


/* DRIVEPRO first-order offer: capture email, then activate the real Shopify discount */
document.addEventListener('DOMContentLoaded',()=>{
  const form=document.getElementById('DriveProNewsletterForm');
  if(!form) return;

  form.addEventListener('submit',async(e)=>{
    e.preventDefault();

    const email=form.querySelector('input[type="email"]');
    const button=form.querySelector('.newsletter-submit');
    const label=button?.querySelector('span');
    const success=form.querySelector('.newsletter-success');
    const error=form.querySelector('.newsletter-error');

    if(!email || !email.checkValidity()) {
      email?.reportValidity();
      return;
    }

    if(error) error.hidden=true;
    if(button) { button.disabled=true; button.classList.add('is-loading'); }
    if(label) label.textContent='UNLOCKING...';

    try {
      /* Save the email as a Shopify customer/newsletter subscriber. */
      const data=new FormData(form);
      const subscribeResponse=await fetch(form.action || '/contact', {
        method:'POST',
        body:data,
        credentials:'same-origin',
        redirect:'manual'
      });

      /*
       * IMPORTANT: do not fetch /discount from JavaScript.
       * Shopify needs a real browser navigation to /discount/CODE so it can
       * set the discount cookie/session. The navigation below does that.
       */
      if(success) success.hidden=false;
      if(label) label.textContent='10% OFF UNLOCKED ✓';

      setTimeout(()=>{
        window.location.href='/discount/DRIVE10?redirect='+encodeURIComponent('/');
      },900);
    } catch(err) {
      console.error('DrivePro newsletter error:',err);
      if(button) { button.disabled=false; button.classList.remove('is-loading'); }
      if(label) label.textContent='GET 10% OFF';
      if(error) error.hidden=false;
    }
  });
});

// V9 custom Buy Now: no Shop Pay / no "More payment options".
document.addEventListener('click', async function(e){
  const btn = e.target.closest('[data-buy-now-v9]');
  if(!btn) return;
  const form = btn.closest('form');
  if(!form || btn.disabled) return;

  const variantInput = form.querySelector('[data-variant-id], input[name="id"]');
  const qtyInput = form.querySelector('input[name="quantity"]');
  const id = variantInput && variantInput.value;
  const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
  if(!id) return;

  const original = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = 'ADDING…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(id), quantity:quantity}]})
    });
    if(!res.ok) throw new Error('Cart add failed');
    window.location.href = '/checkout';
  } catch(err) {
    btn.disabled = false;
    btn.innerHTML = original;
    alert('Something went wrong. Please try again.');
  }
});


// V9 active cart controls
async function v9RefreshCart(){
  const r=await fetch('/cart?view=ajax');
  if(!r.ok) return;
  location.reload();
}
document.addEventListener('click', async function(e){
  const plus=e.target.closest('[data-cart-plus]');
  const minus=e.target.closest('[data-cart-minus]');
  const remove=e.target.closest('[data-cart-remove]');
  if(!plus && !minus && !remove) return;
  const row=e.target.closest('[data-cart-item]');
  if(!row) return;
  const key=row.getAttribute('data-cart-item');
  const input=row.querySelector('[data-cart-qty]');
  let qty=remove?0:Math.max(0,parseInt(input.value||'0',10)+(plus?1:-1));
  try{
    const r=await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    });
    if(!r.ok) throw new Error();
    location.reload();
  }catch(err){ location.reload(); }
});

// Make the tiny product Add to Cart button update the real Shopify cart.
document.addEventListener('submit', async function(e){
  const form=e.target.closest('form.product-form-v4');
  if(!form) return;
  const tiny=e.submitter && e.submitter.classList.contains('tiny-add-cart-v9');
  if(!tiny) return;
  e.preventDefault();
  const id=form.querySelector('input[name="id"]')?.value;
  const qty=Math.max(1,parseInt(form.querySelector('input[name="quantity"]')?.value||'1',10)||1);
  if(!id) return;
  tiny.disabled=true;
  const old=tiny.innerHTML;
  tiny.innerHTML='ADDING…';
  try{
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:qty}]})
    });
    if(!r.ok) throw new Error();
    const cart=await fetch('/cart.js').then(x=>x.json());
    document.querySelectorAll('.cart-icon b').forEach(b=>{b.textContent=cart.item_count;});
    tiny.innerHTML='✓ ADDED TO CART';
    setTimeout(()=>{location.href='/cart';},450);
  }catch(err){
    tiny.disabled=false;
    tiny.innerHTML=old;
    alert('Could not add this item. Please try again.');
  }
});
